/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { withOldUi } from '@userzoomplatform/pe-study-layout';

import CheckRestrictions from './containers/check-restrictions';
import StudyRestrictions from './containers/study-restrictions';
import PreStudy from './containers/pre-study';
import InstallApp from './containers/pre-study/pages/install-app';
import InitParticipant from './containers/init-participant';
import Screener from './containers/screener';
import ModeratedAccessAgreement from './containers/moderated-access-agreement';

import { Forbidden, NotFound, UnexpectedError } from './components/errors';

import Task from './containers/task';
import { inIframe } from './utils/iframe';
import withNewUi from './hocs/with-new-ui';

// TODO: Integrate OldUi with the Task component

const Routes = (): ReactElement => (
	<Switch>
		<Route exact path="/study" component={withNewUi(CheckRestrictions)} />
		<Route exact path="/study-restrictions" component={withNewUi(StudyRestrictions)} />
		<Route exact path="/moderated" render={() => <InitParticipant isModeratedScreener />} />
		<Route exact path="/moderated/study" render={() => <InitParticipant isModeratedStudy />} />
		<Route path="/moderated/access-agreement" component={withOldUi(ModeratedAccessAgreement, { iframeLayout: false, pscl: true })} />
		<Route path="/moderated/screener" component={withOldUi(Screener, { iframeLayout: inIframe, pscl: false })} />
		<Route exact path="/init-participant" component={InitParticipant} />
		<Route path="/pre-study" component={withOldUi(PreStudy, { iframeLayout: inIframe, pscl: true })} />
		<Route path="/mobile/pre-study" component={withOldUi(PreStudy, { iframeLayout: false, pscl: true })} />
		<Route exact path="/task" component={withOldUi(Task, { iframeLayout: inIframe, pscl: false })} />
		<Route exact path="/screener" component={withOldUi(Screener, { iframeLayout: inIframe, pscl: false })} />
		<Route exact path="/install-app" component={withNewUi(InstallApp)} />
		<Route exact path="/forbidden" component={withNewUi(Forbidden)} />
		<Route exact path="/unexpected-error" component={withNewUi(UnexpectedError)} />
		<Route exact path="/not-found" component={withNewUi(NotFound)} />
		<Redirect from="*" to="/not-found" />
	</Switch>
);

export default Routes;
